import { useTranslation } from "react-i18next";
import type {
  ChangeConferenceRoomRequest,
  ChangeConferenceRoomResponse
} from "../../../components/Schedule/ChangeConferenceRoom/change-conference-room.types";
import { RemoteApiError } from "../useRemote/types";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";

/**
 * FE-VM-09: change conference room while preserving booking metadata.
 * Backend: PUT /booking-schedule/change-conference-room (weplace — implement in parallel).
 */
export function useRemoteChangeConferenceRoom() {
  const { t } = useTranslation();

  return useRemoteMutation<
    ChangeConferenceRoomResponse,
    RemoteApiError,
    ChangeConferenceRoomRequest
  >({
    key: ["change-conference-room"],
    url: "/booking-schedule/change-conference-room",
    method: "put",
    snackbarTextOnSuccess: t("_changeRoom_success"),
    snackbarTextOnFail: t("_changeRoom_error")
  });
}
